import { invalidateCache } from 'api/urql/helpers/mutation';

export const updateCustomer = (results, args, cache, info) => {
  invalidateCache('customer')(results, args, cache, info);
};
